import React from 'react';
import Icon from './Icon';

export default function CheckIcon(props) {
  return (
    <Icon width="2.9375rem" height="2.9375rem" viewBox="0 0 47 47" fill="none" {...props}>
      <circle cx="23.5" cy="23.5" r="22.0052" stroke="currentColor" strokeWidth="2" />
    </Icon>
  );
}
